import React from 'react'
import type { Icon } from 'shared/utils'
export const Deals = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'deals',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g fillRule="nonzero">
                <path d="M2.037 12.056c.276 1.9 2.222 3.477 4.861 4.1a8.518 8.518 0 01-.532-1.592c-1.823-.473-3.339-1.36-4.328-2.508h-.001zM7.685 17.555c-2.411-.331-4.43-1.353-5.65-2.771.352 2.409 3.38 4.3 7.108 4.384a8.657 8.657 0 01-1.458-1.613zM2.3 10.223c.046.103.1.202.156.302.02.034.036.07.056.103.055.093.116.184.18.274l.08.11c.066.087.135.175.209.26.028.032.059.063.089.096.25.27.539.524.862.757.05.037.1.075.154.11.086.058.176.115.266.17.07.042.14.086.212.127.088.05.176.097.267.144.084.043.17.084.258.127l.262.121c.11.048.225.092.34.135.071.029.142.058.215.084.088.03.178.056.267.086-.013-.19-.03-.381-.03-.575 0-3.908 2.623-7.21 6.2-8.253C11.44 4.144 10.447 4 9.402 4 5.315 4 2 6.175 2 8.859c0 .474.109.93.3 1.364z" />
                <path d="M14.745 5.398a7.256 7.256 0 00-7.254 7.255 7.255 7.255 0 107.255-7.255zm2.602 7.465c-.268.112-.532.239-.79.373.078.458.256 1.074.483 1.597.295.675-.272 1.145-.922.79-.496-.273-.896-.692-1.353-1.024-.329.264-.646.559-.947.86-.001.006 0 0-.004.005-.295.332-.646.612-.937.481-.255-.115-.332-.48-.274-.852a10.92 10.92 0 01.393-1.71c-.326-.197-.757-.552-1.095-.798-.564-.407-.366-1.302.46-1.196.42.053.886.101 1.271.04.176-.547.282-.932.53-1.451.35-.737.986-.65 1.208 0l.583 1.501c.41.004.819.007 1.228.013.471.007.677.25.722.59.05.362-.263.661-.556.783v-.002z" />
            </g>
        </svg>
    )
}
